import { err, ok } from 'neverthrow'
import { evaluatorErrorWithNode } from '../../scriptevaluator/EvaluatorError'
import { functionNodeTypes, HelperFunction } from '../FunctionTypes'

export const ConceptIdFunction: HelperFunction = {
	tokenName: 'ID',
	nodeType: functionNodeTypes.ConceptId,
	evaluate(node, evaluateExpr) {
		if (node.arguments.length !== 1) {
			return err(evaluatorErrorWithNode('ID function expects exactly one argument', node))
		}
		const result = evaluateExpr(node.arguments[0])
		if (result.isErr()) return err(result.error)
		if (typeof result.value !== 'string') {
			return err(evaluatorErrorWithNode('ID function argument must be a string', node))
		}
		return ok(result.value)
	}
}
